<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="820" persistent scrollable>
    <v-card v-if="settimana">
      <v-card-title class="grey--text text-subtitle-1">
        Nuovo Arrivo
        <span class="font-weight-light ml-2 text-body-2">
          Settimana #{{ settimana.numero + 1 }}
        </span>
        <v-spacer />
        <v-btn icon small @click="chiudi">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pa-4" style="max-height: 75vh;">
        <!-- Selezione fornitore -->
        <v-autocomplete
          v-model="id_fornitore"
          :items="fornitori"
          item-text="nome"
          item-value="id"
          label="Fornitore"
          outlined dense
          prepend-inner-icon="mdi-account"
          :disabled="fornitore_lock"
          :loading="loading_crea_arrivo"
          hide-details
          class="mb-4"
        >
          <template #item="{ item }">
            <v-list-item-avatar size="26">
              <v-img :src="avatarFornitore(item.id)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-caption">{{ item.nome }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <!-- PDF bolla (disponibile solo dopo arrivo creato) -->
        <v-file-input
          v-if="id_arrivo"
          v-model="file_pdf"
          outlined dense
          accept="application/pdf"
          placeholder="Allega PDF bolla (opzionale)"
          prepend-inner-icon="mdi-file-pdf-box"
          label="PDF bolla"
          hide-details
          :loading="loading_pdf"
          class="mb-4"
        />

        <!-- Form aggiunta prodotto -->
        <template v-if="id_arrivo">
          <v-divider class="mb-4" />
          <v-row dense class="mb-3">
            <v-col cols="12" sm="6">
              <v-select
                v-model="id_stagione_sel"
                :items="stagioni_items"
                label="Stagione"
                outlined dense hide-details
                prepend-inner-icon="mdi-calendar-range"
                clearable
              />
            </v-col>
          </v-row>
          <v-row align="center" dense>
            <v-col cols="6">
              <v-autocomplete
                v-model="id_specie"
                :items="specie_disponibili"
                item-text="nome"
                item-value="id"
                label="Specie"
                outlined dense hide-details
                prepend-inner-icon="mdi-spa"
                ref="autocomplete_specie"
              >
                <template #item="{ item }">
                  <v-list-item-avatar size="24">
                    <v-img :src="avatarSpecie(item.id)" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">{{ item.nome }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model.number="qta"
                outlined dense hide-details
                type="number" min="1" label="Qta"
                :disabled="!id_specie"
                ref="campo_qta"
                @keyup.enter="aggiungiProdotto"
              />
            </v-col>
            <v-col cols="2">
              <v-combobox
                v-model="qta_per_cassa"
                :items="qta_per_cassa_suggerite"
                label="x cassa"
                outlined dense hide-details
                type="number"
              />
            </v-col>
            <v-col cols="1" class="text-caption grey--text text-center">
              = {{ qta_to_reg }}
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn icon color="green"
                     :disabled="!id_specie || qta_to_reg < 1"
                     :loading="loading_add_prodotto"
                     @click="aggiungiProdotto">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- Lista prodotti aggiunti -->
          <template v-if="lista_prodotti.length">
            <v-row class="mt-3">
              <v-col cols="6">
                <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">
                  <v-icon x-small class="mr-1">mdi-seed</v-icon>Seme
                </div>
                <v-list dense class="pa-0">
                  <v-list-item
                    v-for="prodotto in lista_seme"
                    :key="prodotto.id"
                    dense class="pa-0"
                    style="min-height: 32px;"
                  >
                    <v-list-item-avatar size="22" class="mr-2 my-0">
                      <v-img :src="avatarSpecie(prodotto.id_specie)" />
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="text-caption">
                        {{ nomeSpecie(prodotto.id_specie) }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="prodotto.id_stagione" class="grey--text font-italic" style="font-size: 10px;">
                        {{ nomeStagione(prodotto.id_stagione) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action-text class="text-body-2 font-weight-medium">
                      {{ prodotto.qta }}
                    </v-list-item-action-text>
                    <v-list-item-action class="my-0 ml-1">
                      <v-btn icon x-small color="red" @click="eliminaProdotto(prodotto.id)">
                        <v-icon x-small>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-divider vertical />
              <v-col cols="6">
                <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">
                  <v-icon x-small class="mr-1">mdi-sprout</v-icon>Talea
                </div>
                <v-list dense class="pa-0">
                  <v-list-item
                    v-for="prodotto in lista_talea"
                    :key="prodotto.id"
                    dense class="pa-0"
                    style="min-height: 32px;"
                  >
                    <v-list-item-avatar size="22" class="mr-2 my-0">
                      <v-img :src="avatarSpecie(prodotto.id_specie)" />
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="text-caption">
                        {{ nomeSpecie(prodotto.id_specie) }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="prodotto.id_stagione" class="grey--text font-italic" style="font-size: 10px;">
                        {{ nomeStagione(prodotto.id_stagione) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action-text class="text-body-2 font-weight-medium">
                      {{ prodotto.qta }}
                    </v-list-item-action-text>
                    <v-list-item-action class="my-0 ml-1">
                      <v-btn icon x-small color="red" @click="eliminaProdotto(prodotto.id)">
                        <v-icon x-small>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </template>
          <v-row v-else class="mt-4">
            <v-col class="text-center text-caption grey--text">
              Nessun prodotto aggiunto ancora
            </v-col>
          </v-row>
        </template>

        <v-alert v-if="errore" type="error" outlined dense class="mt-3">{{ errore }}</v-alert>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="chiudi">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "AggiungiArrivoPiano",
  props: {
    value:              { type: Boolean, default: false },
    settimana:          { type: Object, default: null },
    anno:               { type: [Number, String], required: true },
    fornitori:          { type: Array, default: () => [] },
    specie_disponibili: { type: Array, default: () => [] },
    stagione_attiva:    { type: Object, default: null },
  },
  data() {
    return {
      id_fornitore: null,
      id_arrivo: null,
      fornitore_lock: false,
      loading_crea_arrivo: false,
      id_specie: null,
      qta: 1,
      qta_per_cassa: null,
      qta_per_cassa_suggerite: [],
      loading_add_prodotto: false,
      file_pdf: null,
      loading_pdf: false,
      errore: "",
      id_stagione_sel: null,
    };
  },
  created() {
    const stored = localStorage.getItem("qta_per_cassa_suggerite");
    if (stored) {
      try { this.qta_per_cassa_suggerite = JSON.parse(stored); }
      catch { this.qta_per_cassa_suggerite = []; }
    }
  },
  watch: {
    value(val) {
      if (!val) this.resetForm();
    },
    id_fornitore(val) {
      if (!val) return;
      this.creaArrivo(val);
    },
    file_pdf(file) {
      if (!file) return;
      this.uploadPdf(file);
    },
    stagione_attiva: {
      immediate: true,
      handler(val) { this.id_stagione_sel = val?.id ?? null; },
    },
  },
  computed: {
    qta_to_reg() {
      const x = Number(this.qta_per_cassa);
      if (x && !isNaN(x) && x > 0) return this.qta * x;
      return this.qta;
    },
    lista_prodotti() {
      if (!this.id_arrivo) return [];
      return this.$store.getters.get_lista_prodotti_arrivo({
        anno:         this.anno,
        id_settimana: this.settimana?.id,
        id_arrivo:    this.id_arrivo,
      });
    },
    lista_seme() {
      return this.lista_prodotti.filter((p) => {
        return this.specie_disponibili.find((s) => s.id == p.id_specie)?.propagazione == 1;
      });
    },
    lista_talea() {
      return this.lista_prodotti.filter((p) => {
        return this.specie_disponibili.find((s) => s.id == p.id_specie)?.propagazione == 2;
      });
    },
    stagioni_items() {
      const stagioni = this.$store.getters.getStagioniColtivazione || [];
      return stagioni.map((s) => ({
        value: s.id,
        text: `${s.tipo_stagione?.nome || "Stagione"} ${s.anno}`,
      }));
    },
  },
  methods: {
    avatarFornitore(id) {
      return process.env.VUE_APP_API_ROOT + "/fornitore/" + id + "/avatar";
    },
    avatarSpecie(id) {
      return process.env.VUE_APP_API_ROOT + "/specie/" + id + "/img";
    },
    nomeSpecie(id) {
      return this.specie_disponibili.find((s) => s.id == id)?.nome || "Specie #" + id;
    },
    nomeStagione(id_stagione) {
      const stagioni = this.$store.getters.getStagioniColtivazione || [];
      const s = stagioni.find((s) => s.id == id_stagione);
      return s ? `${s.tipo_stagione?.nome || "Stagione"} ${s.anno}` : null;
    },
    async creaArrivo(id_fornitore) {
      this.loading_crea_arrivo = true;
      this.errore = "";
      try {
        const arrivo = await this.$store.dispatch("aggiungi_arrivo_settimana", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_fornitore,
        });
        this.id_arrivo = arrivo.id;
        this.fornitore_lock = true;
      } catch {
        this.errore = "Impossibile creare l'arrivo. Riprovare.";
        this.id_fornitore = null;
      } finally {
        this.loading_crea_arrivo = false;
      }
    },
    async aggiungiProdotto() {
      if (!this.id_specie || this.qta_to_reg < 1) return;
      this.loading_add_prodotto = true;
      this.errore = "";
      try {
        await this.$store.dispatch("aggiungi_prodotto_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.id_arrivo,
          id_specie:    this.id_specie,
          qta:          this.qta_to_reg,
          id_stagione:  this.id_stagione_sel,
        });
        // Aggiorna suggerimenti qta_per_cassa
        const x = Number(this.qta_per_cassa);
        if (x && !isNaN(x) && !this.qta_per_cassa_suggerite.includes(x)) {
          this.qta_per_cassa_suggerite.push(x);
          this.qta_per_cassa_suggerite.sort((a, b) => a - b);
          localStorage.setItem(
            "qta_per_cassa_suggerite",
            JSON.stringify(this.qta_per_cassa_suggerite)
          );
        }
        this.id_specie = null;
        this.qta = 1;
        this.$nextTick(() => {
          this.$refs.autocomplete_specie?.focus();
        });
      } catch {
        this.errore = "Errore durante l'aggiunta del prodotto.";
      } finally {
        this.loading_add_prodotto = false;
      }
    },
    async eliminaProdotto(id_prodotto) {
      this.errore = "";
      try {
        await this.$store.dispatch("rimuovi_prodotto_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.id_arrivo,
          id_prodotto,
        });
      } catch {
        this.errore = "Errore durante l'eliminazione.";
      }
    },
    async uploadPdf(file) {
      this.loading_pdf = true;
      const formData = new FormData();
      formData.append("file", file);
      const url =
        process.env.VUE_APP_API_ROOT +
        "/admin/calendario_arrivi/arrivo/" +
        this.id_arrivo +
        "/pdf";
      const auth = this.$store.getters.get_credential;
      try {
        await axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          auth,
        });
        this.$store.commit("set_nome_pdf_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.id_arrivo,
          file_name:    file.name,
        });
        this.file_pdf = null;
      } catch {
        this.errore = "Errore durante l'upload del PDF.";
      } finally {
        this.loading_pdf = false;
      }
    },
    chiudi() {
      this.$emit("input", false);
    },
    resetForm() {
      this.id_fornitore = null;
      this.id_arrivo = null;
      this.fornitore_lock = false;
      this.id_specie = null;
      this.qta = 1;
      this.errore = "";
      this.file_pdf = null;
      this.id_stagione_sel = this.stagione_attiva?.id ?? null;
    },
  },
};
</script>
